<template>
  <!-- No tw- display classes here: Tailwind is !important and would beat v-show -->
  <div v-show="open" class="dialer-panel elevation-8">
    <div class="dialer-panel__header">
      <span class="tw-font-medium">Dialer</span>

      <v-btn
        icon
        small
        aria-label="Close dialer"
        @click="$store.commit('dialer/setOpen', false)"
      >
        <v-icon small>close</v-icon>
      </v-btn>
    </div>

    <div class="tw-p-3 tw-flex-1 tw-overflow-y-auto">
      <DialerCallBar v-if="activeCall" />
      <DialerWrapUp v-if="activeCall && activeCall.status === 'wrapup'" />

      <v-text-field
        :value="number"
        :disabled="!!activeCall"
        label="Phone number"
        hide-details
        class="tw-mb-3"
        @input="typeNumber"
        @keyup.enter="call"
      />

      <DialerKeypad />

      <BaseButton
        v-if="!activeCall"
        variant="secondary"
        block
        class="tw-mt-3"
        :disabled="!number"
        @click="call"
      >
        Call
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { BaseButton } from '@bambeehr/pollen';
import { mapState } from 'vuex';

import DialerCallBar from '@/components/dialer/DialerCallBar';
import DialerKeypad from '@/components/dialer/DialerKeypad';
import DialerWrapUp from '@/components/dialer/DialerWrapUp';

export default {
  name: 'DialerPanel',

  components: {
    BaseButton,
    DialerCallBar,
    DialerKeypad,
    DialerWrapUp,
  },

  computed: {
    ...mapState('dialer', ['open', 'number', 'target', 'activeCall', 'error']),
  },

  watch: {
    error(message) {
      if (message) {
        this.$toast.show({
          text: message,
          color: 'error',
          timeout: 5000,
          dismissible: true,
        });
        this.$store.commit('dialer/setError', '');
      }
    },
  },

  methods: {
    async call() {
      const error = await this.$store.dispatch('dialer/dial', {
        phone: this.number,
        ...(this.target || {}),
      });

      if (error) {
        this.$store.commit('dialer/setError', error);
      }
    },

    // A hand-typed number isn't tied to the lead it was prefilled from
    typeNumber(value) {
      this.$store.commit('dialer/setNumber', value);
      this.$store.commit('dialer/setTarget', null);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialer-panel {
  background: #ffffff;
  border-radius: 8px;
  bottom: 16px;
  display: flex;
  flex-direction: column;
  height: 520px;
  max-height: calc(100vh - 80px);
  max-width: calc(100vw - 32px);
  position: fixed;
  right: 16px;
  width: 340px;
  z-index: 200;

  &__header {
    align-items: center;
    border-bottom: 1px solid #e8e8ec;
    display: flex;
    height: 48px;
    justify-content: space-between;
    padding: 0 12px;
  }
}
</style>
